// Determine environment
const isLocalhost = false;
const isProd = false;
const isDev = true;

// Base URLs based on environment
export const BASE_URL = isLocalhost
  ? `${process.env.REACT_APP_BASE_URL_LOCAL}` // Localhost
  : isProd
    ? `${process.env.REACT_APP_BASE_URL_PROD}` // Production
    : `${process.env.REACT_APP_BASE_URL_DEV}`; // Development

export const DIS_BASE_URL = isLocalhost
  ? `${process.env.REACT_APP_DIS_BASE_URL_LOCAL}` // Localhost
  : isProd
    ? `${process.env.REACT_APP_DIS_BASE_URL_PROD}` // Production
    : `${process.env.REACT_APP_DIS_BASE_URL_DEV}`; // Development

console.log(`Running in ${isProd ? 'Production' : isDev ? 'Development' : 'Localhost'} mode`);
console.log(`Base URL: ${BASE_URL}`);
console.log(`Dispatch URL: ${process.env.REACT_APP_BASE_URL_LOCAL}`);
console.log(`Dispatch URL: ${process.env.REACT_APP_BASE_URL_PROD}`);
console.log(`Dispatch URL: ${process.env.REACT_APP_BASE_URL_DEV}`);
